import { AxiosResponse, CancelToken } from 'axios';

import { loginApi } from '../setup/setupApi';
import { launcherApi } from '../setup/setupLauncherApi';
import {
  ConnectedLaunchers,
  ConnectedLaunchersNew,
  CreateLoginParams,
  CreateLoginResponse,
  getConnectedLaunchersProps,
  LoginProjectData,
  MauStatistic,
  UserStatistic
} from './types';

// Dashboard requests

export const getLoginProjects = (
  publisherId: number,
  publisherProjectId: number
): Promise<Array<LoginProjectData>> =>
  loginApi
    .get(`projects`, {
      params: { publisher_id: publisherId, publisher_project_id: publisherProjectId }
    })
    .then((res) => res.data);

export const getProjectStatistic = (
  projectId: string,
  date: string,
  cancelToken?: CancelToken
): Promise<UserStatistic & MauStatistic> =>
  loginApi
    .get(`projects/${projectId}/users_statistics`, {
      params: { date },
      cancelToken
    })
    .then((res) => res.data);

export const createLoginProject = (
  merchantId: number,
  publisherProjectId: number,
  data: CreateLoginParams
): Promise<CreateLoginResponse> =>
  loginApi
    .post<CreateLoginParams, AxiosResponse<CreateLoginResponse>>('projects', data, {
      params: {
        publisher_id: merchantId,
        publisher_project_id: publisherProjectId,
        is_ng_verification: true
      }
    })
    .then((res) => res.data);

export const getConnectedLaunchers = ({
  merchantId,
  loginProjectId
}: getConnectedLaunchersProps): Promise<ConnectedLaunchers> =>
  launcherApi
    .get('projects', {
      params: { publisher_id: merchantId, xsolla_login_project_id: loginProjectId }
    })
    .then((res) => res.data);

export const getConnectedLaunchersNew = ({
  merchantId,
  loginProjectId
}: getConnectedLaunchersProps): Promise<ConnectedLaunchersNew> =>
  launcherApi
    .get(`login_projects/${loginProjectId}`, {
      params: { merchant_id: merchantId }
    })
    .then((res) => res.data);
